import React from 'react';
import { HIGHLIGHTERS, Highlighter } from '../../lib/paper';

/** Zig-zag torn ends: 5 teeth per edge (same outline as mobile's Tape). */
function tornOutline(w: number, h: number): string {
  const teeth = 5;
  const d = 2.5;
  const pts: string[] = [];
  for (let i = 0; i <= teeth; i += 1) pts.push(`${i % 2 ? d : 0},${(h / teeth) * i}`);
  for (let i = teeth; i >= 0; i -= 1) pts.push(`${w - (i % 2 ? d : 0)},${(h / teeth) * i}`);
  return pts.join(' ');
}

/**
 * A strip of translucent washi tape, as if something was taped to the page.
 * Absolutely position it over a card's edge via `className`; it ignores clicks.
 */
export const Tape: React.FC<{
  tone?: Highlighter;
  width?: number;
  height?: number;
  rotate?: number;
  className?: string;
}> = ({ tone = HIGHLIGHTERS.yellow, width = 64, height = 20, rotate = -4, className = '' }) => (
  <svg
    aria-hidden
    width={width}
    height={height}
    className={`pointer-events-none absolute ${className}`}
    style={{ transform: `rotate(${rotate}deg)` }}
  >
    <polygon points={tornOutline(width, height)} fill={tone.fill} opacity={0.88} />
    {/* Faint woven stripes so it reads as tape, not a sticker. */}
    {[0.3, 0.55, 0.8].map((t) => (
      <line
        key={t}
        x1={4}
        x2={width - 4}
        y1={height * t}
        y2={height * t}
        stroke={tone.ink}
        strokeOpacity={0.07}
        strokeWidth={1}
      />
    ))}
  </svg>
);
